import { Component } from '@angular/core';
import { membersuiteFiscalYearEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Fiscal Years') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitefiscalyear-form',
    templateUrl: './membersuitefiscalyear.form.component.html'
})
export class membersuiteFiscalYearFormComponent extends BaseFormComponent {
    public record!: membersuiteFiscalYearEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

